module.exports = __webpack_public_path__ + "img/arrow2.e67bd099.svg";